import type { ShiftBreak, ShiftEvent } from '@libs/data-access/queries'
import moment from 'moment'

export const getBreaksFromEvents = (
  shiftEvents: ShiftEvent[],
  shiftBreaks: ShiftBreak[],
  shiftIsFinishedWithoutOut = false
) => {
  const declaredShiftBreaks = shiftEvents.filter(
    shiftEvent => shiftEvent.event_type === 'break_duration'
  )

  const shiftEventBreakStart = shiftEvents
    ?.filter(shiftEvent => shiftEvent.event_type === 'break_start')
    .sort(
      (a, b) =>
        new Date(a.event_occurred_at).getTime() -
        new Date(b.event_occurred_at).getTime()
    )
  const shiftEventBreakEnd = shiftEvents
    ?.filter(shiftEvent => shiftEvent.event_type === 'break_end')
    .sort(
      (a, b) =>
        new Date(a.event_occurred_at).getTime() -
        new Date(b.event_occurred_at).getTime()
    )

  const breakStartShiftEvents = shiftEventBreakStart ?? []

  const breakEndShiftEvents = shiftEventBreakEnd ?? []

  const createdBreaks: ShiftBreak[] = []

  if (declaredShiftBreaks.length) {
    declaredShiftBreaks.forEach(shiftBreak => {
      const item: ShiftBreak = {
        // @ts-ignore because legacy
        id: null,
        planned_duration:
          shiftBreaks?.find(
            breakItem => breakItem.id === shiftBreak.shift_break_id
          )?.planned_duration || 0,
        // @ts-ignore because legacy
        planned_ends_at: null,
        // @ts-ignore because legacy
        planned_starts_at: null,
        // @ts-ignore because legacy
        real_duration: shiftBreak.value,
        // @ts-ignore because legacy
        real_ends_at: null,
        // @ts-ignore because legacy
        real_starts_at: null,
        event_type: 'break_duration',
        shift_event_ids: [shiftBreak.id].filter(Boolean),
        // @ts-ignore because legacy
        shift_id: null
      }

      createdBreaks.push(item)
    })
  }

  if (breakStartShiftEvents) {
    breakStartShiftEvents.forEach(startBreak => {
      const start = startBreak.event_occurred_at
      const end = breakEndShiftEvents.length
        ? breakEndShiftEvents[0].event_occurred_at
        : null

      let breakDuration = end
        ? moment.duration(moment(end).diff(moment(start)))
        : 0

      /* Since we are using 2 different libraries (dateFNS and momentJS) to make some calculation and those two libraries have different behavior.
       We're streamlining the data by checking if the seconds are superior to 30 to add a minute.
       This way we're emulating how dateFNS performs its minute difference calculation  */

      if (typeof breakDuration !== 'number') {
        breakDuration = Number(breakDuration.asMinutes().toFixed(0))
      }

      const item: ShiftBreak = {
        // @ts-ignore because legacy
        id: null,
        planned_duration:
          shiftBreaks?.find(
            breakItem => breakItem?.id === startBreak.shift_break_id
          )?.planned_duration || 0,
        // @ts-ignore because legacy
        planned_ends_at: null,
        // @ts-ignore because legacy
        planned_starts_at: null,
        real_duration: breakDuration,
        real_ends_at: end ? moment(end).format() : moment(start).format(),
        real_starts_at: moment(start).format(),
        // @ts-ignore because legacy
        shift_event_ids: [
          Number(startBreak.id),
          end && Number(breakEndShiftEvents[0]?.id)
        ].filter(Boolean),
        // @ts-ignore because legacy
        shift_id: null,
        event_type: 'break_start_end'
      }

      if (breakEndShiftEvents.length === 0 && !shiftIsFinishedWithoutOut) {
        return createdBreaks
      }

      if (breakEndShiftEvents) {
        breakEndShiftEvents.shift()
      }

      createdBreaks.push(item)
    })
  }

  return createdBreaks
}
